import { helper } from '@ember/component/helper';

export default helper(function jsonStringify(positional /*, named*/) {
  console.log('positional = ', positional);
  return JSON.stringify(positional);
});
